import { isPlatformBrowser } from '@angular/common';
import type { OnChanges, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import type { HeartbeatTrackingCancellation } from './tracking.model';
import { Tracking } from './tracking.service';

@Component({
  standalone: false,
  selector: `fl-heartbeat-tracking`,
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeartbeatTrackingComponent implements OnChanges, OnDestroy {
  private tracking = inject(Tracking);
  private platformId = inject(PLATFORM_ID);

  @Input() name: string;
  @Input() referenceType?: string;
  @Input() referenceId?: number | string;

  cancel: HeartbeatTrackingCancellation;

  async ngOnChanges(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cancel) {
        this.cancel();
      }
      this.cancel = await this.tracking.trackHeartbeat(
        this.name,
        this.referenceType,
        this.referenceId?.toString(),
      );
    }
  }

  ngOnDestroy(): void {
    this.cancel?.();
  }
}
